import colors from "../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const FooterStyle = makeStyles((theme) => ({
	footerRoot: { display: "flex" },
	topStrip: {
		position: "fixed",
		height: "5px",
		bottom: 60,
		left: 0,
		width: "100%",
		backgroundColor: colors.primary,
		zIndex: 1000,
	},
	bottomBar: {
		position: "fixed",
		height: "60px",
		bottom: 0,
		left: 0,
		width: "100%",
		backgroundColor: colors.black,
		zIndex: 1000,
	},
	footerLinks: {
		color: colors.white,
		padding: theme.spacing(2),
		fontSize: "14px",
		[theme.breakpoints.down("sm")]: {
			textAlign: "center",
		},
	},
	links: {
		color: colors.white,
		cursor: "pointer",
		textDecoration: "none",
	},
}));

export default FooterStyle;
